import React, { useEffect, useState } from 'react';
import { ArrowRight, Save, Loader2, CheckCircle } from 'lucide-react';
import { useApi } from './DashboardLayout';

export default function IndikationMappingPage() {
  const { apiFetch } = useApi();
  const [mappings, setMappings] = useState({});
  const [dropdownValues, setDropdownValues] = useState([]);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      apiFetch('/api/settings/indikation-mapping').then(r => r?.json()),
      apiFetch('/api/dropdowns').then(r => r?.json())
    ]).then(([mapData, ddData]) => {
      if (mapData?.mappings) setMappings(mapData.mappings);
      if (ddData) {
        const hd = ddData.find(d => d.name === 'Hauptindikation');
        if (hd) {
          const vals = Array.isArray(hd.dropdown_values) ? hd.dropdown_values : [];
          setDropdownValues(vals);
          // Ensure all dropdown values have a mapping entry
          const merged = { ...mapData?.mappings };
          vals.forEach(v => { if (!(v in merged)) merged[v] = ''; });
          setMappings(merged);
        }
      }
      setLoading(false);
    });
  }, []);

  const handleSave = async () => {
    setSaving(true); setSaved(false);
    await apiFetch('/api/settings/indikation-mapping', {
      method: 'POST',
      body: JSON.stringify({ mappings })
    });
    setSaving(false); setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div data-testid="indikation-mapping-page">
      <div className="page-header">
        <h2>Indikation & Positionsnummern</h2>
        <p>Verknüpfung zwischen Hauptindikationen und abrechenbaren Positionsnummern konfigurieren.</p>
      </div>

      <div className="card">
        <div className="card-body">
          <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: '1.25rem', lineHeight: 1.6 }}>
            Wenn ein Anbieter beim Anlegen eines Angebots eine Hauptindikation auswählt, wird die zugehörige Positionsnummer automatisch eingetragen.
          </div>

          {loading ? (
            <div className="empty-state"><Loader2 size={24} className="spin" /></div>
          ) : (
            <>
              <table data-testid="mapping-table">
                <thead>
                  <tr>
                    <th style={{ width: '50%' }}>Hauptindikation</th>
                    <th style={{ width: 40, textAlign: 'center' }}></th>
                    <th>Abrechenbare Positionsnummer</th>
                  </tr>
                </thead>
                <tbody>
                  {dropdownValues.map(indikation => (
                    <tr key={indikation} data-testid={`mapping-row-${indikation}`}>
                      <td style={{ fontWeight: 500 }}>{indikation}</td>
                      <td style={{ textAlign: 'center', color: 'var(--text-muted)' }}><ArrowRight size={16} /></td>
                      <td>
                        <input
                          className="form-input"
                          value={mappings[indikation] || ''}
                          onChange={e => setMappings(prev => ({ ...prev, [indikation]: e.target.value }))}
                          placeholder="z.B. 604504"
                          style={{ fontFamily: 'monospace', fontSize: 13, margin: 0 }}
                          data-testid={`mapping-input-${indikation}`}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: '1.25rem' }}>
                <button className="btn btn-primary" onClick={handleSave} disabled={saving} data-testid="mapping-save-btn">
                  {saving ? <><Loader2 size={14} className="spin" /> Speichern...</> : <><Save size={14} /> Speichern</>}
                </button>
                {saved && (
                  <span style={{ fontSize: 13, color: '#16a34a', display: 'flex', alignItems: 'center', gap: 4 }}>
                    <CheckCircle size={14} /> Gespeichert
                  </span>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
